/* Lysverden: anchor the predictive-search panel to the header search bar.
   Horizon centres the panel at a fixed offset from the top of the viewport. We
   want it pinned to the search bar instead, so the panel's own input row lands
   exactly on top of the bar and the suggestions hang below it.
   The offset can't be a CSS constant: the header is sticky and the announcement
   bar scrolls away above it, so the bar sits ~68px down at rest and ~18px once
   scrolled. This publishes the live rect as custom properties. */
(() => {
  const BAR = '.header__row--top .search-action';
  const DIALOG = '#search-modal dialog';

  const visibleBar = () =>
    [...document.querySelectorAll(BAR)].find((el) => el.offsetParent !== null);

  const sync = () => {
    const dialog = document.querySelector(DIALOG);
    if (!dialog || !dialog.open) return;

    const bar = visibleBar();
    // No visible bar means the mobile layout, where the panel keeps its own
    // full-width positioning. Clear the vars so CSS falls back to defaults.
    if (!bar) {
      dialog.style.removeProperty('--lv-search-left');
      dialog.style.removeProperty('--lv-search-top');
      dialog.style.removeProperty('--lv-search-width');
      return;
    }

    const rect = bar.getBoundingClientRect();
    dialog.style.setProperty('--lv-search-left', `${Math.round(rect.left)}px`);
    dialog.style.setProperty('--lv-search-top', `${Math.round(rect.top)}px`);
    dialog.style.setProperty('--lv-search-width', `${Math.round(rect.width)}px`);
  };

  const watch = (dialog) => {
    new MutationObserver(sync).observe(dialog, {
      attributes: true,
      attributeFilter: ['open'],
    });
  };

  const start = () => {
    const dialog = document.querySelector(DIALOG);
    if (dialog) watch(dialog);

    addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
